import { BankOperationAllTypesChoices, BankOperationValue } from 'constants/bankOperationTypes';

import { BankOperationType } from 'types/embedded/bankOperation';

export function getFilteredBankOpsTypes(bankOps: BankOperationType[], omit?: BankOperationValue[]) {
  const availableBankOps = new Set(BankOperationAllTypesChoices);
  const excludedBankOps = new Set(omit);
  const normalizedBankOps = bankOps.filter((bankOp) => availableBankOps.has(bankOp.value));

  return normalizedBankOps.filter((bankOp) => !excludedBankOps.has(bankOp.value));
}
